<template>
  <div class="admin-conversation-info rounded">
    <div class="px-3 py-2">
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Operator</h6>
        </div>
        <div class="col-6 mt-1">
          <span>
            {{ operatorInformation ? `${operatorInformation.fname} ${operatorInformation.lname}` : "" }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Opened</h6>
        </div>
        <div class="col-6 mt-1">
          <span>{{ formatTimestamp(conversationDetail.created_at, "M/D/YY h:mm a") }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Closed</h6>
        </div>
        <div class="col-6 mt-1">
          <span>
            {{ conversationDetail.status != 'active' ? formatTimestamp(conversationDetail.closed_at, "M/D/YY h:mm a") : '' }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Language</h6>
        </div>
        <div
          v-if="conversationDetail.recipients && conversationDetail.recipients.length > 0"
          class="col-6 mt-1"
        >
          <span>{{ dialectLabel(conversationDetail.recipients[0].language) }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Messages</h6>
        </div>
        <div class="col-6 mt-1">
          <span>{{ conversationDetail.message_count }}</span>
        </div>
      </div>
    </div>
    <div v-if="recordedAudioAttachments.length > 0" class="admin-conversation-info--audio px-3 py-2 border-top d-flex flex-wrap gap-2">
      <MediaItem
        v-for="attachment in recordedAudioAttachments"
        recordedAudio
        :key="attachment.attachment_id"
        :attachmentId="attachment.attachment_id"
        :attachment="attachment"
        :processed="attachment.status === 'processed'"
      />
    </div>
    <div v-if="keywords.length > 0" class="admin-conversation-info--keywords px-3 py-2 border-top d-flex flex-wrap gap-2">
      <div
        v-for="keyword in keywords"
        :key="`${keyword.id}-${keyword.term}`"
        :class="`keyword-item text-nowrap d-flex justify-content-center align-items-center fs-3 px-2 py-1 urgency-level-${keyword.data ? keyword.data.level : 1}`"
      >
        {{ keyword.term }}
      </div>
    </div>
    <div v-show="hasSummary" class="admin-conversation-info--summary px-3 py-2 border-top">
      <div :id="`conversationSummary-${conversationId}`"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/events/eventBus";
import moment from "moment-timezone";
import errorHandler from "@/mixins/errorHandler";
import MediaItem from "@/components/MediaItem";

export default {
  name: "AdminConversationInfo",
  mixins: [errorHandler],
  components: {
    MediaItem,
  },
  props: {
    conversationDetail: Object,
    conversationAttachments: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      operatorInformation: null,
      fetchAbortController: null,
      hasSummary: false,
    };
  },
  computed: {
    ...mapGetters("agency", ["textDialects"]),
    ...mapGetters("keywords", ["keywords"]),
    conversationId() {
      return this.$route.params.conversationId
    },
    recordedAudioAttachments() {
      return this.conversationAttachments.filter(attachment => attachment.content_type.toLowerCase() === 'audio/pcm');
    },
  },
  created() {
    this.hasSummary = false;
    EventBus.$on("update-conversation-summary", (data) => {
      const { isNew, data: summary, conversationId } = data;
      if (conversationId === this.conversationId && summary) {
        this.hasSummary = true;
      }
    });
  },
  methods: {
    async loadOperatorInformation(operatorId) {
      try {
        this.fetchAbortController = new AbortController();
        const resp = await this.$ConveyApi.usersApi.getUser({
          userId: operatorId,
          signal: this.fetchAbortController.signal,
        });
        this.operatorInformation = resp.data.data;
      } catch(err) {
        if (!this.isApiCanceled(err)) {
          console.log("[AdminConversationInfo:loadOperatorInformation] ERROR: ", err);
        }
      }
    },
    formatTimestamp(t, format = "LT") {
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const formattedTime = moment.utc(t, "x").tz(tz).format(format);
        return formattedTime;
      } catch (e) {
        return t;
      }
    },
    dialectLabel(code) {
      let languageLabel = code;
      try {
        languageLabel = this.textDialects.find(o => o.code === code).label;
      } catch (error) {
        return code;
      }
      return languageLabel;
    },
  },
  watch: {
    conversationDetail: {
      async handler(conversation) {
        if (conversation && conversation.operator_id) {
          await this.loadOperatorInformation(conversation.operator_id);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.fetchAbortController) {
      this.fetchAbortController.abort();
      this.fetchAbortController = null;
    }
  }
};
</script>

<style lang="scss">
.admin-conversation-info {
  width: 100%;
  max-width: 1024px;

  &--audio {
  }
  &--summary {
    min-height: 2.25rem;
  }
  &--keywords {
    height: auto;
    min-height: 2.25rem;
    max-height: 300px;
    overflow-y: auto;

    .keyword-item {
      width: fit-content;
      height: 1.25rem;
      border-radius: 1rem;
      color: white;
      background-color: #186dde;
      &.urgency-level-1 {
        background-color: #ef5350;
      }
      &.urgency-level-2 {
        background-color: #ffb22b;
      }
    }
  }
}
</style>
